import {
  RIDeparmentHome,
  RiInspectionReportCreate,
  RiInspectionReportList,
} from '../pages/RIDeparment';
import { VendirList } from '../pages/RIDeparment/MasterListOfVendor';

import { Production } from '../pages/ProductionPage';
import UnderConstructionPage from '../underconstruction-page';
import {
  DailyProduction,
  CreateDailyProduction,
} from '../pages/ProductionPage/dailyProductionRotor';
import PressShopSection from '../pages/ProductionPage/PressShopSectionIdeal';

import {
  ProcessControlStandardCreate,
  ProcessControlStandardList,
} from '../pages/processControlStandard';

import { Pir, PirTableList } from '../pages/pir';
import {
  PreventiveMaintenancePlanChecklistCreate,
  PreventiveMaintenancePlanChecklistList,
  PreventiveMaintenancePlanPlanCreate,
  PreventiveMaintenancePlanPlanList,
  PreventiveMaintenancePlanTiles,
} from '../pages/preventiveMaintenancePlan';
import {
  ToolPreventiveMaintenancePlanChecklistCreate,
  ToolPreventiveMaintenancePlanChecklistList,
  ToolPreventiveMaintenancePlanPlanCreate,
  ToolPreventiveMaintenancePlanPlanList,
  ToolPreventiveMaintenancePlanTiles,
} from '../pages/toolPreventivePlan';

import { ScrapNoteList, CreateScrapNote } from '../pages/scrapNote';
import {
  CreateMachineChkSht,
  MachineCheckSheetHome,
  MachineChkShtList,
} from '../pages/machineCheckSheet';
import ToolsList from '../pages/masterlisofTools/List';
import { CriticalSparePartsList } from '../pages/masterListOfCriticalSpareParts';
import CreateMachineHistory from '../pages/masterlistofMachine/machineHistory/CreateMachineHistory';
import {
  ProcessRejectionTiles,
  CapaAnalysisFormatsUpload,
} from '../pages/redBinMonitoringSheet';
import {
  ProcessRejectionList,
  ProcessRejectionCreate,
} from '../pages/redBinMonitoringSheet/processRejection';
import ProcessRejectionDashboardTabs from '../pages/redBinMonitoringSheet/rejectionNoteDashboard/RejectionAnalysisDashboardTabs';
import ProcessRejectionDashBoardList from '../pages/redBinMonitoringSheet/rejectionNoteDashboard/TableList';
import {
  BreakDownAnalysisGraphTabs,
  BreakDownAnalysisGraphList,
} from '../pages/clause3';
import ToolsHistory from '../pages/masterlisofTools/toolsHistory/CreateToolHistory';
import { MushinHelpDesk } from '../pages/Mushin_Help_Desk';
import {
  CreateForMSetup,
  CreateForMSummary,
  SummaryTableList,
  CreateHoldCard,
  TrainingRecord,
} from '../pages/4m';
import { QualityAlertList } from '../pages/qualityAlert';
import {
  Clause5,
  CreateEditTopicPaper,
  DepartmentList,
  EmployeeList,
  FacultyList,
  MaterListTniCategory,
  QuickViewTopicPaper,
  TNITiles,
  TniCsrPlanChecklistList,
  TniCsrPlanCreate,
  TniCsrPlanList,
  TniCsrPlanTiles,
  TniTopicList,
  TniTrainingPlanChecklistList,
  TniTrainingPlanCreate,
  TniTrainingPlanList,
  TniTrainingPlanTiles,
  TrainingCalenderTiles,
  TrainingTniHome,
  TniPlanList,
  TniPlanCreate,
  MaterListSkillCategory,
  SkillEvaluationHome,
  CreateEditTopicSkillPaper,
  ViewTopicSkillPaper,
  SkillMatrixCreate,
  SkillMatrixList,
} from '../pages/clause5page';
import {
  InHouseComplaintList,
  MasterProcedureUpload,
} from '../pages/clause8Page';
import { AbnormalityHandlingProcedureUpload } from '../pages/clause3';
import {
  MasterFormatsUpload,
  MasterProcedureNewUpload,
  WorkInstructionsUpload,
} from '../pages/clause4Page';
import {
  AttendanceMonthList,
  AttendanceReportView,
} from '../pages/attendanceResister';
import BreakdownAnalysis from '../pages/clause3/breakdownAnalysis';
import BreakdownCapaAnalysisFormatsUpload from '../pages/clause3/capaAnalysisFormatsUpload/MasterFormatsUpload';
import NewToolList from '../pages/masterlisofToolsNewICPL/List';
import NewToolHistory from '../pages/masterlisofToolsNewICPL/toolsHistory/CreateToolHistory';
import ListOfProcedures from '../pages/listOfProcedures/listOfProcedures';
import {
  QualityChecksheetsHome,
  NoiseMonitoringReportList,
  CreateNoiseMonitoringReport,
  MachineSafetyCheckSheetsList,
  CreateMachineSafetyCheckSheet,
  PokaYokeChkShtList,
  CreatePokaYokeChkSht,
  PokaYokeMachineCheckList,
  CreatePokaYokeMachineCheckList,
} from '../pages/qualityChecksheets';
import {
  LuxMonitoringReportList,
  CreateLuxMonitoringReport,
} from '../pages/qualityChecksheets';
import {
  MasterListOfGauges,
  MasterListOfFixtures,
  GaugeMaintenanceTiles,
  GaugeMaintenancePlanList,
  GaugeMaintenancePlanCreate,
  GaugeMaintenanceStatus,
  GaugeMaintenanceChecklist,
  GaugeMaintenanceStatusCheckList,
  GaugeMaintenanceChecklistCreate,
} from '../pages/clause10Page';
import { KaizenSubmissionList } from '../pages/kaizen';
import { Management5S } from '../pages/management5S';
import { PfdUploadDocList } from '../pages/pfduploaddoc';
import {
  ProcessAndProductAuditPlanList,
  ProcessAndProductAuditPlanCreate,
  ProcessAndProductAuditChecklistList,
  ProcessAndProductAuditChecklistCreate,
  ProcessAndProductAuditCreateSummarySheet,
  MasterListOfProcess,
  ProcessAuditPlan_Tiles,
  ProcessAuditPlan_PlanList,
  ProcessAuditPlan_PlanCreate,
  ProcessAuditPlan_Status,
  ProcessAuditPlan_Checklist,
  ProcessAuditPlan_StatusCheckList,
  ProcessAuditPlan_ChecklistCreate,
  ProductAuditPlanTiles,
  ProductAuditPlanChecklistList,
  ProductAuditPlanCreate,
  ProductAuditPlanList,
  ProductAuditReportCreate,
  ProductAuditReportList,
  RevalidationChecklist,
  RevalidationChecklistCreate,
  RevalidationPlanCreate,
  RevalidationPlanList,
  RevalidationStatus,
  RevalidationStatusCheckList,
  RevalidationTiles,
  MispPartTable,
  MispStandardsCreate,
  ProductAuditCreateSummarySheet,
  ProductAuditPlanOldChecklistCreate,
} from '../pages/clause6';
import {
  InstrumentMasterList,
  InstrumentHistoryCard,
  MasterListLocationList,
  TilesCallibration,
  TilesMsa,
  MsaPlanList,
  MsaPlanCreate,
  MsaChecklistList,
  PlanList,
  PlanCreate,
  ChecklistList,
} from '../pages/clause15';
import InstrumentsTiles from '../pages/clause15/InstrumentsTiles';
import { BreakDownSlipList, CreateBreakDownSlip } from '../pages/breakDownSlip';
import {
  ToolPreventiveMaintenancePlanNewChecklist,
  ToolPreventiveMaintenancePlanNewChecklistCreate,
  ToolPreventiveMaintenancePlanNewCreate,
  ToolPreventiveMaintenancePlanNewList,
  ToolPreventiveMaintenancePlanNewStatus,
  ToolPreventiveMaintenancePlanNewStatusCheckList,
  ToolPreventiveMaintenancePlanNewTiles,
} from '../pages/clause10Page/toolPrevantiveMaintenancePlanNew';
import { clause5new } from './common/clause5';
import { CreateGaugeSheet, GaugeList } from '../pages/clause15/gaugeSheet';
import Ppslist from '../pages/uploadPPS/List';

interface routes {
  path: string;
  element: JSX.Element;
  errorElement?: string;
}
export const clause10 = [
  {
    path: 'gauges/list',
    element: <MasterListOfGauges />,
  },
  {
    path: 'fixtures/list',
    element: <MasterListOfFixtures />,
  },
  // gauge plan
  {
    path: 'gaugeMaintenanceTiles',
    element: <GaugeMaintenanceTiles />,
  },
  {
    path: 'gaugeMaintenancePlanList',
    element: <GaugeMaintenancePlanList />,
  },
  {
    path: 'gaugeMaintenancePlanCreate/:id',
    element: <GaugeMaintenancePlanCreate />,
  },
  {
    path: 'gaugeMaintenanceStatus',
    element: <GaugeMaintenanceStatus />,
  },
  {
    path: 'gaugeMaintenanceChecklist',
    element: <GaugeMaintenanceChecklist />,
  },
  {
    path: 'gaugeMaintenanceChecklistCreate/:id?',
    element: <GaugeMaintenanceChecklistCreate />,
  },
  {
    path: 'gaugeMaintenanceStatusCheckList/:id?',
    element: <GaugeMaintenanceStatusCheckList />,
  },
];

export const redBinMonitoringSheet = [
  {
    path: 'redBinMonitoringSheet',
    element: <ProcessRejectionTiles />,
  },
  {
    path: 'redBinMonitoringSheet/dailyProductionList',
    element: <ProcessRejectionList />,
  },
  {
    path: 'createEditProcessRejection/:id?',
    element: <ProcessRejectionCreate />,
  },
  {
    path: 'redBinMonitoringSheet/dashboard',
    element: <ProcessRejectionDashboardTabs />,
  },
  {
    path: 'redBinMonitoringSheet/dashboardList',
    element: <ProcessRejectionDashBoardList />,
  },
  {
    path: 'capaAnalysisFormatsUpload',
    element: <CapaAnalysisFormatsUpload />,
  },
];

const productionRoute = [
  {
    path: 'production',
    element: <Production />,
  },
  // {
  //   path: 'dailyProductionList',
  //   element: <DailyProduction />,
  // },

  // daily prod press shop report report
  {
    path: 'production/pressShop',
    element: <PressShopSection />,
  },
  {
    path: 'production/pressShop/dailyProductionList',
    element: <DailyProduction />,
  },
  {
    path: 'production/pressShop/createEditDailyProduction/:id?',
    element: <CreateDailyProduction />,
  },
  // break down slip
  {
    path: 'breakDownSlipList',
    element: <BreakDownSlipList />,
  },
  {
    path: 'createEditBreakDownSlip/:id?',
    element: <CreateBreakDownSlip />,
  },
];
const pirRoute = [
  {
    path: 'pirList',
    element: <PirTableList />,
  },
  {
    path: 'pir/:partId/:pirId?',
    element: <Pir />,
  },
];
// preventive maintenance plan

const preventiveMaintenance = [
  {
    path: 'preventiveMaintenancePlanTiles',
    element: <PreventiveMaintenancePlanTiles />,
  },
  {
    path: 'preventiveMaintenancePlanPlanList',
    element: <PreventiveMaintenancePlanPlanList />,
  },
  {
    path: 'preventiveMaintenancePlanCreate/:id',
    element: <PreventiveMaintenancePlanPlanCreate />,
  },
  {
    path: 'preventiveMaintenancePlanChecklistList',
    element: <PreventiveMaintenancePlanChecklistList />,
  },
  {
    path: 'preventiveMaintenancePlanChecklistCreate/:moduleId?/:checklistType?',
    element: <PreventiveMaintenancePlanChecklistCreate />,
  },
];

// tool preventive maintenance plan

const toolPreventiveMaintenance = [
  {
    path: 'toolPreventiveMaintenancePlanTiles',
    element: <ToolPreventiveMaintenancePlanTiles />,
  },
  {
    path: 'toolPreventiveMaintenancePlanPlanList',
    element: <ToolPreventiveMaintenancePlanPlanList />,
  },
  {
    path: 'toolPreventiveMaintenancePlanCreate/:id',
    element: <ToolPreventiveMaintenancePlanPlanCreate />,
  },
  {
    path: 'toolPreventiveMaintenancePlanChecklistList',
    element: <ToolPreventiveMaintenancePlanChecklistList />,
  },
  {
    path: 'toolPreventiveMaintenancePlanChecklistCreate/:moduleId?/:checklistType?',
    element: <ToolPreventiveMaintenancePlanChecklistCreate />,
  },
];

// new
const newToolPreventiveMaintenancePlan = [
  {
    path: 'toolPreventiveMaintenancePlanNewTiles',
    element: <ToolPreventiveMaintenancePlanNewTiles />,
  },
  {
    path: 'toolPreventiveMaintenancePlanNewPlanList',
    element: <ToolPreventiveMaintenancePlanNewList />,
  },
  {
    path: 'toolPreventiveMaintenancePlanNewCreate/:id',
    element: <ToolPreventiveMaintenancePlanNewCreate />,
  },
  {
    path: 'toolPreventiveMaintenancePlanNewStatus',
    element: <ToolPreventiveMaintenancePlanNewStatus />,
  },
  {
    path: 'toolPreventiveMaintenancePlanNewChecklist',
    element: <ToolPreventiveMaintenancePlanNewChecklist />,
  },
  {
    path: 'toolPreventiveMaintenancePlanNewStatusCheckList/:id?',
    element: <ToolPreventiveMaintenancePlanNewStatusCheckList />,
  },
  {
    path: 'toolPreventiveMaintenancePlanNewChecklistCreate/:id?',
    element: <ToolPreventiveMaintenancePlanNewChecklistCreate />,
  },
];

// machine check sheet
const machinCheckSheet = [
  {
    path: 'machineCheckSheet',
    element: <MachineCheckSheetHome />,
  },
  {
    path: 'MachineCheckSheetList',
    element: <MachineChkShtList />,
  },
  {
    path: 'createMachineCheckSheet',
    element: <CreateMachineChkSht />,
  },
];
const forMSummary = [
  {
    path: 'create4mSummary',
    element: <CreateForMSummary />,
  },
  {
    path: '4mSummaryList',
    element: <SummaryTableList />,
  },
  {
    path: 'create4mSetup/:partId/:rowId/:setupId?',
    element: <CreateForMSetup />,
  },
  {
    path: 'createHoldCard/:id?',
    element: <CreateHoldCard />,
  },
  {
    path: 'trainingRecord/:id?',
    element: <TrainingRecord />,
  },
];
const clause3 = [
  {
    path: 'abnormalityHandlingProcedureUpload',
    element: <AbnormalityHandlingProcedureUpload />,
  },
  {
    path: 'breakDownAnalysisGraphTabs/dashboard',
    element: <BreakDownAnalysisGraphTabs />,
  },
  {
    path: 'breakDownAnalysisGraph/dashboardList',
    element: <BreakDownAnalysisGraphList />,
  },
  {
    path: 'breakdownAnalysisSheet',
    element: <BreakdownAnalysis />,
  },
  {
    path: 'breakdownCapaAnalysisFormatsUpload',
    element: <BreakdownCapaAnalysisFormatsUpload />,
  },
];
const clause4 = [
  {
    path: 'masterFormatsUpload',
    element: <MasterFormatsUpload />,
  },
  {
    path: 'masterProcedureNewUpload',
    element: <MasterProcedureNewUpload />,
  },
  {
    path: 'workInstructionsUpload',
    element: <WorkInstructionsUpload />,
  },
];
const clause8 = [
  {
    path: 'masterProcedureUpload',
    element: <MasterProcedureUpload />,
  },
  {
    path: 'inHouseComplaintRegister',
    element: <InHouseComplaintList />,
  },
];

// clause 5
const clause5 = [
  {
    path: 'clause5',
    element: <Clause5 />,
  },
  {
    path: 'employee_list',
    element: <EmployeeList />,
  },
  {
    path: 'department_list',
    element: <DepartmentList />,
  },
  {
    path: 'masterlistoffaculty',
    element: <FacultyList />,
  },
  //tni
  {
    path: 'trainingTniHome',
    element: <TrainingTniHome />,
  },
  {
    path: 'tniTiles',
    element: <TNITiles />,
  },
  {
    path: 'topicPaper/list',
    element: <TniTopicList />,
  },
  {
    path: 'createEditTopicPaper/:id?',
    element: <CreateEditTopicPaper />,
  },
  {
    path: 'quick_view_topic_paper/:id',
    element: <QuickViewTopicPaper />,
  },
  {
    path: 'masterlistofTniCategory',
    element: <MaterListTniCategory />,
  },
  {
    path: 'trainingCalenderTiles',
    element: <TrainingCalenderTiles />,
  },
  //tni end
  //tni plan
  {
    path: 'tniPlanList',
    element: <TniPlanList />,
  },
  {
    path: 'tniPlanCreate/:id',
    element: <TniPlanCreate />,
  },
  //training plan
  {
    path: 'tniTrainingPlanTiles',
    element: <TniTrainingPlanTiles />,
  },
  {
    path: 'tniTrainingPlanList',
    element: <TniTrainingPlanList />,
  },
  {
    path: 'tniTrainingPlanCreate/:id',
    element: <TniTrainingPlanCreate />,
  },
  {
    path: 'tniTraningPlanChecklistList',
    element: <TniTrainingPlanChecklistList />,
  },
  //csr plan
  {
    path: 'tniCsrPlanTiles',
    element: <TniCsrPlanTiles />,
  },
  {
    path: 'tniCsrPlanList',
    element: <TniCsrPlanList />,
  },
  {
    path: 'tniCsrPlanCreate/:id',
    element: <TniCsrPlanCreate />,
  },
  {
    path: 'tniCsrPlanChecklistList',
    element: <TniCsrPlanChecklistList />,
  },
  //skill Evaluation
  {
    path: 'skillEvaluationHome',
    element: <SkillEvaluationHome />,
  },
  {
    path: 'skillEvaluationCategoryList',
    element: <MaterListSkillCategory />,
  },
  {
    path: 'createEditTopicSkillPaper/:categoryId?',
    element: <CreateEditTopicSkillPaper />,
  },
  {
    path: 'viewTopicSkillPaper/:categoryId',
    element: <ViewTopicSkillPaper />,
  },
  {
    path: 'skillMatrixList',
    element: <SkillMatrixList />,
  },
  {
    path: 'skillMatrixCreate/:id',
    element: <SkillMatrixCreate />,
  },
];

const qualityChecksheets = [
  {
    path: 'qualityChecksheets',
    element: <QualityChecksheetsHome />,
  },
  {
    path: 'qualityChecksheets/noiseMonitoringReportList',
    element: <NoiseMonitoringReportList />,
  },
  {
    path: 'qualityChecksheets/createNoiseMonitoringReport/:id?',
    element: <CreateNoiseMonitoringReport />,
  },
  {
    path: 'qualityChecksheets/machineSafetyCheckSheetsList',
    element: <MachineSafetyCheckSheetsList />,
  },
  {
    path: 'qualityChecksheets/createMachineSafetyCheckSheet/:id?',
    element: <CreateMachineSafetyCheckSheet />,
  },
  {
    path: 'qualityChecksheets/luxMonitoringReportList',
    element: <LuxMonitoringReportList />,
  },
  {
    path: 'qualityChecksheets/createLuxMonitoringReport/:id?',
    element: <CreateLuxMonitoringReport />,
  },
  {
    path: 'qualityChecksheets/pokaYokeCheckSheetList',
    element: <PokaYokeChkShtList />,
  },
  {
    path: 'qualityChecksheets/createPokaYokeCheckSheet',
    element: <CreatePokaYokeChkSht />,
  },
  {
    path: 'qualityChecksheets/pokaYokeMachineCheckList',
    element: <PokaYokeMachineCheckList />,
  },
  {
    path: 'qualityChecksheets/createPokaYokeMachineCheckList',
    element: <CreatePokaYokeMachineCheckList />,
  },
  // {
  //   path: 'hpdcChecksheets/operatorChecksheet',
  //   element: <OperatorCheckSheetsList />,
  // },
  // {
  //   path: 'hpdcChecksheets/createOperatorChecksheet/:id?',
  //   element: <CreateOperatorCheckSheet />,
  // },

  // {
  //   path: 'hpdcChecksheets/supervisorChecksheet',
  //   element: <SupervisorCheckSheetsList />,
  // },
  // {
  //   path: 'hpdcChecksheets/createSupervisorChecksheet/:id?',
  //   element: <CreateSupervisorCheckSheet />,
  // },
];

export const Clause6 = [
  {
    path: 'processAndProductAuditPlanList',
    element: <ProcessAndProductAuditPlanList />,
  },
  {
    path: 'processAndProductAuditPlanCreate/:id',
    element: <ProcessAndProductAuditPlanCreate />,
  },
  {
    path: 'processAndProductAuditChecklistList',
    element: <ProcessAndProductAuditChecklistList />,
  },
  {
    path: 'processAndProductAuditChecklistCreate/:moduleId?',
    element: <ProcessAndProductAuditChecklistCreate />,
  },
  {
    path: 'summarySheet/:id',
    element: <ProcessAndProductAuditCreateSummarySheet />,
  },
  {
    path: 'masterListOfProcess',
    element: <MasterListOfProcess />,
  },
  // process audit plan new
  {
    path: 'processAuditTiles',
    element: <ProcessAuditPlan_Tiles />,
  },
  {
    path: 'processAuditPlan_PlanList',
    element: <ProcessAuditPlan_PlanList />,
  },
  {
    path: 'processAuditPlan_PlanCreate/:id',
    element: <ProcessAuditPlan_PlanCreate />,
  },
  {
    path: 'processAuditPlan_Status',
    element: <ProcessAuditPlan_Status />,
  },
  {
    path: 'processAuditPlan_Checklist',
    element: <ProcessAuditPlan_Checklist />,
  },
  {
    path: 'processAuditPlan_ChecklistCreate/:id?',
    element: <ProcessAuditPlan_ChecklistCreate />,
  },
  {
    path: 'processAuditPlan_StatusCheckList/:id?',
    element: <ProcessAuditPlan_StatusCheckList />,
  },
  //product  audit plan old
  {
    path: 'productAuditPlanTiles',
    element: <ProductAuditPlanTiles />,
  },
  {
    path: 'productAuditPlanList',
    element: <ProductAuditPlanList />,
  },
  {
    path: 'productAuditPlanCreate/:id',
    element: <ProductAuditPlanCreate />,
  },
  {
    path: 'productAuditPlanChecklistList',
    element: <ProductAuditPlanChecklistList />,
  },
  {
    path: 'productAuditReportCreate/:partId/:id?',
    element: <ProductAuditReportCreate />,
  },
  {
    path: 'productAuditReportList/:partId',
    element: <ProductAuditReportList />,
  },
  {
    path: 'productAuditPlanOldChecklistCreate/:moduleId?',
    element: <ProductAuditPlanOldChecklistCreate />,
  },
  //misp standard
  {
    path: 'mispPartTable',
    element: <MispPartTable />,
  },
  {
    path: 'mispStandardsCreate/:partId',
    element: <MispStandardsCreate />,
  },
  {
    path: 'productAuditSummarySheet/:id',
    element: <ProductAuditCreateSummarySheet />,
  },
];
const revaditionPlan = [
  {
    path: 'revalidationPlanTiles',
    element: <RevalidationTiles />,
  },
  {
    path: 'revalidationPlanList',
    element: <RevalidationPlanList />,
  },
  {
    path: 'revalidationPlanCreate/:id',
    element: <RevalidationPlanCreate />,
  },
  {
    path: 'revalidationStatus',
    element: <RevalidationStatus />,
  },
  {
    path: 'revalidationChecklist',
    element: <RevalidationChecklist />,
  },
  {
    path: 'revalidationChecklistCreate/:id?',
    element: <RevalidationChecklistCreate />,
  },
  {
    path: 'revalidationStatusCheckList/:id?',
    element: <RevalidationStatusCheckList />,
  },
];
const instrumentClause15 = [
  {
    path: 'instrumentMasterlist',
    element: <InstrumentMasterList />,
  },
  {
    path: 'instrumentHistoryCard/:id',
    element: <InstrumentHistoryCard />,
  },
  {
    path: 'masterListLocationList',
    element: <MasterListLocationList />,
  },
  {
    path: 'instrumentsTiles',
    element: <InstrumentsTiles />,
  },
  {
    path: 'tilesCallibrationplan',
    element: <TilesCallibration />,
  },
  {
    path: 'tilesMsaplan',
    element: <TilesMsa />,
  },
  {
    path: 'createGaugeRepeatability/:partId/:id?',
    element: <CreateGaugeSheet />,
  },
  {
    path: 'gaugeRepeatability',
    element: <GaugeList />,
  },
  {
    path: 'instrumentplanlist',
    element: <PlanList />,
  },
  {
    path: 'instrumentplancreate/:id',
    element: <PlanCreate />,
  },
  {
    path: 'msaplanlist',
    element: <MsaPlanList />,
  },
  {
    path: 'msaplancreate/:id',
    element: <MsaPlanCreate />,
  },
  {
    path: 'msachecklistList',
    element: <MsaChecklistList />,
  },
  {
    path: 'checklistList',
    element: <ChecklistList />,
  },
];

export const IndexCommon: routes[] = [
  {
    path: 'riDepartment',
    element: <RIDeparmentHome />,
  },
  {
    path: 'masterListOfVendor',
    element: <VendirList />,
  },
  // machine and tools
  // tools and critical spare parts
  {
    path: 'masterlistofToolsNewIcpl',
    element: <NewToolList />,
  },
  {
    path: 'toolsHistoryNewIcpl/:id',
    element: <NewToolHistory />,
  },
  {
    path: 'masterlistofTools',
    element: <ToolsList />,
  },
  {
    path: 'masterListOfCriticalSparePart',
    element: <CriticalSparePartsList />,
  },
  {
    path: 'machineHistory/:id',
    element: <CreateMachineHistory />,
  },
  {
    path: 'toolsHistory/:id',
    element: <ToolsHistory />,
  },

  // press shop
  {
    path: 'riDepartment/inspectionReportList',
    element: <RiInspectionReportList />,
  },
  {
    path: 'riDepartment/createInspectionReport/:partId/:moduleId?',
    element: <RiInspectionReportCreate />,
  },
  // process control standard in view ppap
  {
    path: 'processControlStandardList/:partId',
    element: <ProcessControlStandardList />,
  },
  {
    path: 'processControlStandardCreate/:partId/:id?',
    element: <ProcessControlStandardCreate />,
  },
  // scrap note
  {
    path: 'scrapNoteList',
    element: <ScrapNoteList />,
  },
  {
    path: 'createEditScrapNote/:id?',
    element: <CreateScrapNote />,
  },
  // upload pps in view ppap
  {
    path: 'ppsList/:partID',
    element: <Ppslist />,
  },
  //Mushin Help Desk
  {
    path: 'mushinHelpDesk',
    element: <MushinHelpDesk />,
  },

  //quality alert
  {
    path: 'qualityAlertList',
    element: <QualityAlertList />,
  },

  // attendance resister
  {
    path: 'attendanceResisterListMonthWise',
    element: <AttendanceMonthList />,
  },
  {
    path: 'editAttendancResister',
    element: <AttendanceReportView />,
  },
  {
    path: 'company_roles_responsibilities_listOfProcedures',
    element: <ListOfProcedures />,
  },
  {
    path: 'certificatesAndStandards',
    element: <ListOfProcedures />,
  },
  {
    path: 'kaizenSubmissionList',
    element: <KaizenSubmissionList />,
  },
  {
    path: 'management5S',
    element: <Management5S />,
  },
  {
    path: 'pfdUploadDocList',
    element: <PfdUploadDocList />,
  },

  ...productionRoute,
  ...pirRoute,
  ...preventiveMaintenance,
  ...toolPreventiveMaintenance,
  ...machinCheckSheet,
  ...redBinMonitoringSheet,
  ...forMSummary,
  ...clause5,
  ...clause3,
  ...clause4,
  ...clause8,
  ...qualityChecksheets,
  ...clause10,
  ...Clause6,
  ...instrumentClause15,
  ...revaditionPlan,
  ...newToolPreventiveMaintenancePlan,
  ...clause5new,
];
